import { render, staticRenderFns } from "./CreatorReviewPrompt.vue?vue&type=template&id=0ca2d319&"
import script from "./CreatorReviewPrompt.vue?vue&type=script&lang=js&"
export * from "./CreatorReviewPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports